import { useMemo } from 'react';
import TextParser from '@naruto/naruto-models/src/core/text-parser';
import TimeParser from '@naruto/naruto-models/src/core/time-parser';
import Utility from '@naruto/naruto-models/src/core/utility';
import UrlParser from '@naruto/naruto-models/src/core/url-parser';
import PasswordValidator from '@naruto/naruto-models/src/core/passwordValidator';
import LocalStorageOperator from '@naruto/naruto-models/src/core/localStorageOperator';

export interface useTools<LocalStorageOperatorType = string> {
  textParser: TextParser;
  timeParser: TimeParser;
  utility: Utility;
  urlParser: UrlParser;
  passwordValidator: PasswordValidator;
  localStorageOperator: LocalStorageOperator<LocalStorageOperatorType>;
}

/**
 * 描述 : 取得常用 functions
 */
export default function useTools<LocalStorageOperatorType = string>(): useTools<LocalStorageOperatorType> {
  /* Main */
  return useMemo(
    () => ({
      textParser: new TextParser(),
      timeParser: new TimeParser(),
      utility: new Utility(),
      urlParser: new UrlParser(),
      passwordValidator: new PasswordValidator(),
      localStorageOperator: new LocalStorageOperator<LocalStorageOperatorType>()
    }),
    []
  );
}
